import { render, staticRenderFns } from "./importChargeTab.vue?vue&type=template&id=2f45189b&scoped=true&"
import script from "./importChargeTab.vue?vue&type=script&lang=js&"
export * from "./importChargeTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f45189b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f45189b')) {
      api.createRecord('2f45189b', component.options)
    } else {
      api.reload('2f45189b', component.options)
    }
    module.hot.accept("./importChargeTab.vue?vue&type=template&id=2f45189b&scoped=true&", function () {
      api.rerender('2f45189b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/importCharge/importChargeTab.vue"
export default component.exports